import tinymce from 'tinymce';

tinymce.addI18n('it', {
  Redo: 'Ripristina',
  Undo: 'Annulla',
  Cut: 'Taglia',
  Copy: 'Copia',
  Paste: 'Incolla',
  'Select all': 'Seleziona tutto',
  'New document': 'Nuovo documento',
  Ok: 'OK',
  Cancel: 'Annulla',
  'Visual aids': 'Aiuti visivi',
  Bold: 'Grassetto',
  Italic: 'Corsivo',
  Underline: 'Sottolineato',
  Strikethrough: 'Barrato',
  Superscript: 'Apice',
  Subscript: 'Pedice',
  'Clear formatting': 'Cancella la formattazione',
  Remove: 'Rimuovi',
  'Align left': 'Allinea a sinistra',
  'Align center': 'Allinea al centro',
  'Align right': 'Allinea a destra',
  'No alignment': 'Senza allineamento',
  Justify: 'Giustifica',
  'Bullet list': 'Elenco puntato',
  'Numbered list': 'Elenco numerato',
  'Decrease indent': 'Riduci rientro',
  'Increase indent': 'Aumenta rientro',
  Close: 'Chiudi',
  Formats: 'Formati',
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Il browser non supporta l'accesso diretto alla cartella degli appunti. Usare i tasti di scelta rapida Ctrl+X/C/V.",
  Headings: 'Titoli',
  'Heading 1': 'Titolo 1',
  'Heading 2': 'Titolo 2',
  'Heading 3': 'Titolo 3',
  'Heading 4': 'Titolo 4',
  'Heading 5': 'Titolo 5',
  'Heading 6': 'Titolo 6',
  Preformatted: 'Preformattato',
  Div: 'Div',
  Pre: 'Pre',
  Code: 'Codice',
  Paragraph: 'Paragrafo',
  Blockquote: 'Citazione',
  Inline: 'In linea',
  Blocks: 'Blocchi',
  'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.':
    'Incolla \xe8 in modalit\xe0 testo normale. I contenuti saranno incollati come testo normale se non viene disattivata questa opzione.',
  Fonts: 'Caratteri',
  'Font sizes': 'Dimensioni font',
  Class: 'Classe',
  'Browse for an image': "Cerca un'immagine",
  OR: 'OPPURE',
  'Drop an image here': "Rilasciare un'immagine qui",
  Upload: 'Carica',
  'Uploading image': 'Caricamento immagine',
  Block: 'Blocco',
  Align: 'Allinea',
  Default: 'Predefinito',
  Circle: 'Circolo',
  Disc: 'Disco',
  Square: 'Quadrato',
  'Lower Alpha': 'Alfabetico minuscolo',
  'Lower Greek': 'Greco minuscolo',
  'Lower Roman': 'Romano minuscolo',
  'Upper Alpha': 'Alfabetico maiuscolo',
  'Upper Roman': 'Romano maiuscolo',
  'Anchor...': 'Ancoraggio...',
  Anchor: 'Ancora',
  Name: 'Nome',
  ID: 'ID',
  'ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.':
    'ID dovrebbe iniziare con una lettera, seguita solo da lettere, numeri, trattini, punti, due punti.',
  'You have unsaved changes are you sure you want to navigate away?':
    'Ci sono modifiche non salvate, si \xe8 sicuro di volere uscire?',
  'Restore last draft': "Ripristina l'ultima bozza",
  'Special character...': 'Carattere speciale...',
  'Special Character': 'Carattere Speciale',
  'Source code': 'Codice sorgente',
  'Insert/Edit code sample': 'Inserisci/modifica esempio di codice',
  Language: 'Lingua',
  'Code sample...': 'Esempio di codice...',
  'Left to right': 'Da sinistra a destra',
  'Right to left': 'Da destra a sinistra',
  Title: 'Titolo',
  Fullscreen: 'A tutto schermo',
  Action: 'Azione',
  Shortcut: 'Collegamento',
  Help: 'Guida',
  Address: 'Indirizzo',
  'Focus to menubar': 'Imposta stato attivo per la barra dei menu',
  'Focus to toolbar': 'Imposta stato attivo per la barra degli strumenti',
  'Focus to element path': "Imposta stato attivo per il percorso dell'elemento",
  'Focus to contextual toolbar':
    'Imposta stato attivo per la barra degli strumenti contestuale',
  'Insert link (if link plugin activated)':
    "Inserisci un collegamento (se \xe8 attivato l'apposito plugin)",
  'Save (if save plugin activated)':
    "Salva (se \xe8 attivato l'apposito plugin)",
  'Find (if searchreplace plugin activated)':
    "Trova (se \xe8 attivato l'apposito plugin)",
  'Plugins installed ({0}):': 'Plugin installati ({0}):',
  'Premium plugins:': 'Plugin Premium:',
  'Learn more...': 'Maggiori informazioni...',
  'You are using {0}': 'Si sta utilizzando {0}',
  Plugins: 'Plugin',
  'Handy Shortcuts': 'Scorciatoie utili',
  'Horizontal line': 'Linea orizzontale',
  'Insert/edit image': 'Inserisci/modifica immagine',
  'Alternative description': 'Descrizione alternativa',
  Accessibility: 'Accessibilit\xe0',
  'Image is decorative': "L'immagine \xe8 decorativa",
  Source: 'Fonte',
  Dimensions: 'Dimensioni',
  'Constrain proportions': 'Mantieni proporzioni',
  General: 'Generali',
  Advanced: 'Avanzate',
  Style: 'Stile',
  'Vertical space': 'Spazio verticale',
  'Horizontal space': 'Spazio orizzontale',
  Border: 'Bordo',
  'Insert image': 'Inserisci immagine',
  'Image...': 'Immagine...',
  'Image list': 'Elenco immagini',
  Resize: 'Ridimensiona',
  'Insert date/time': 'Inserisci data/ora',
  'Date/time': 'Data/ora',
  'Insert/edit link': 'Inserisci/modifica collegamento',
  'Text to display': 'Testo da visualizzare',
  Url: 'URL',
  'Open link in...': 'Apri collegamento in...',
  'Current window': 'Finestra corrente',
  None: 'Nessuno',
  'New window': 'Nuova finestra',
  'Open link': 'Apri link',
  'Remove link': 'Rimuovi collegamento',
  Anchors: 'Ancoraggi',
  'Link...': 'Collegamento...',
  'Paste or type a link': 'Incolla o digita un collegamento',
  'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?':
    "L'URL inserito sembra essere un indirizzo email. Si vuole aggiungere il necessario prefisso mailto:?",
  'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?':
    "L'URL inserito sembra essere un collegamento esterno. Si vuole aggiungere il necessario prefisso http://?",
  'The URL you entered seems to be an external link. Do you want to add the required https:// prefix?':
    "L'URL inserito sembra essere un collegamento esterno. Si vuole aggiungere il necessario prefisso http://?",
  'Link list': 'Elenco collegamenti',
  'Insert video': 'Inserisci video',
  'Insert/edit video': 'Inserisci/modifica video',
  'Insert/edit media': 'Inserisci/modifica oggetti multimediali',
  'Alternative source': 'Sorgente alternativa',
  'Alternative source URL': 'URL sorgente alternativa',
  'Media poster (Image URL)':
    "Poster dell'oggetto multimediale (URL dell'immagine)",
  'Paste your embed code below:':
    "Incolla il codice d'incorporamento di seguito:",
  Embed: 'Incorpora',
  'Media...': 'Oggetto multimediale...',
  'Nonbreaking space': 'Spazio indivisibile',
  'Page break': 'Interruzione di pagina',
  'Paste as text': 'Incolla senza formattazioni',
  Preview: 'Anteprima',
  Print: 'Stampa',
  'Print...': 'Stampa...',
  Save: 'Salva',
  Find: 'Trova',
  'Replace with': 'Sostituisci con',
  Replace: 'Sostituisci',
  'Replace all': 'Sostituisci tutto',
  Previous: 'Indietro',
  Next: 'Avanti',
  'Find and Replace': 'Trova e sostituisci',
  'Find and replace...': 'Trova e sostituisci...',
  'Could not find the specified string.':
    'Impossibile trovare la stringa specificata.',
  'Match case': 'Maiuscole/minuscole',
  'Find whole words only': 'Trova solo parole intere',
  'Find in selection': 'Trova nella selezione',
  'Insert table': 'Inserisci tabella',
  'Table properties': 'Propriet\xe0 della tabella',
  'Delete table': 'Elimina tabella',
  Cell: 'Cella',
  Row: 'Riga',
  Column: 'Colonna',
  'Cell properties': 'Propriet\xe0 cella',
  'Merge cells': 'Unisci le celle',
  'Split cell': 'Dividi la cella',
  'Insert row before': 'Inserisci riga prima',
  'Insert row after': 'Inserisci riga dopo',
  'Delete row': 'Elimina riga',
  'Row properties': 'Propriet\xe0 della riga',
  'Cut row': 'Taglia riga',
  'Cut column': 'Taglia colonna',
  'Copy row': 'Copia riga',
  'Copy column': 'Copia colonna',
  'Paste row before': 'Incolla riga prima',
  'Paste column before': 'Inserisci colonna prima',
  'Paste row after': 'Incolla riga dopo',
  'Paste column after': 'Inserisci colonna dopo',
  'Insert column before': 'Inserisci colonna prima',
  'Insert column after': 'Inserisci colonna dopo',
  'Delete column': 'Elimina colonna',
  Cols: 'Colonne',
  Rows: 'Righe',
  Width: 'Larghezza',
  Height: 'Altezza',
  'Cell spacing': 'Spaziatura tra celle',
  'Cell padding': 'Spaziatura interna celle',
  'Row clipboard actions': 'Azioni appunti riga',
  'Column clipboard actions': 'Azioni appunti colonna',
  'Table styles': 'Stili tabella',
  'Cell styles': 'Stili cella',
  'Column header': 'Intestazione colonna',
  'Row header': 'Intestazione riga',
  'Table caption': 'Titolo tabella',
  Caption: 'Didascalia',
  'Show caption': 'Mostra didascalia',
  Left: 'Sinistra',
  Center: 'Centro',
  Right: 'Destra',
  'Cell type': 'Tipo di cella',
  Scope: 'Ambito',
  Alignment: 'Allineamento',
  'Horizontal align': 'Allineamento orizzontale',
  'Vertical align': 'Allineamento verticale',
  Top: 'In alto',
  Middle: 'Centrato',
  Bottom: 'In basso',
  'Header cell': "Cella d'intestazione",
  'Row group': 'Gruppo di righe',
  'Column group': 'Gruppo di colonne',
  'Row type': 'Tipo di riga',
  Header: 'Intestazione',
  Body: 'Corpo',
  Footer: 'Pi\xe8 di pagina',
  'Border color': 'Colore del bordo',
  Solid: 'Pieno',
  Dotted: 'Puntini',
  Dashed: 'Trattini',
  Double: 'Doppio',
  Groove: 'Groove',
  Ridge: 'Ridge',
  Inset: '',
  Outset: '',
  Hidden: 'Nascosto',
  'Insert template...': 'Inserisci modello...',
  Templates: 'Modelli',
  Template: 'Modello',
  'Insert Template': 'Inserisci modello',
  'Text color': 'Colore testo',
  'Background color': 'Colore dello sfondo',
  'Custom...': 'Personalizzato...',
  'Custom color': 'Colore personalizzato',
  'No color': 'Nessun colore',
  'Remove color': 'Rimuovi colore',
  'Show blocks': 'Mostra blocchi',
  'Show invisible characters': 'Mostra caratteri invisibili',
  'Word count': 'Conteggio parole',
  Count: 'Conteggio',
  Document: 'Documento',
  Selection: 'Selezione',
  Words: 'Parole',
  'Words: {0}': 'Parole: {0}',
  '{0} words': '{0} parole',
  File: 'File',
  Edit: 'Modifica',
  Insert: 'Inserisci',
  View: 'Visualizza',
  Format: 'Formato',
  Table: 'Tabella',
  Tools: 'Strumenti',
  'Powered by {0}': 'Con tecnologia {0}',
  'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help':
    'Area di testo RTF. Premere ALT-F9 per il menu. Premere ALT-F10 per la barra degli strumenti. Premere ALT-0 per la guida.',
  'Image title': 'Titolo immagine',
  'Border width': 'Larghezza del bordo',
  'Border style': 'Stile del bordo',
  Error: 'Errore',
  Warn: 'Avviso',
  Valid: 'Valido',
  'To open the popup, press Shift+Enter':
    'Per aprire il popup, premere Shift+Invio',
  'Rich Text Area': 'Area di testo ricco',
  'Rich Text Area. Press ALT-0 for help.':
    'Area di testo RTF. Premere ALT-0 per la guida.',
  'System Font': 'Carattere di sistema',
  'Failed to upload image: {0}': 'Caricamento immagine fallito: {0}',
  'Failed to load plugin: {0} from url {1}':
    "Caricamento plugin fallito: {0} dall'URL {1}",
  'Failed to load plugin url: {0}': 'Caricamento URL plugin fallito: {0}',
  'Failed to initialize plugin: {0}': 'Inizializzazione plugin fallita: {0}',
  example: 'esempio',
  Search: 'Cerca',
  All: 'Tutto',
  Currency: 'Valuta',
  Text: 'Testo',
  Quotations: 'Citazioni',
  Mathematical: 'Caratteri matematici',
  'Extended Latin': 'Latino esteso',
  Symbols: 'Simboli',
  Arrows: 'Frecce',
  'User Defined': "Definito dall'utente",
  'dollar sign': 'simbolo del dollaro',
  'currency sign': 'simbolo di valuta',
  'euro-currency sign': "simbolo dell'euro",
  'colon sign': 'simbolo del col\xf3n',
  'cruzeiro sign': 'simbolo del cruzeiro',
  'french franc sign': 'simbolo del franco francese',
  'lira sign': 'simbolo della lira',
  'mill sign': 'simbolo del mill',
  'naira sign': 'simbolo della naira',
  'peseta sign': 'simbolo della peseta',
  'rupee sign': 'simbolo della rup\xeca',
  'won sign': 'simbolo del won',
  'new sheqel sign': 'simbolo del nuovo shekel',
  'dong sign': 'simbolo del dong',
  'kip sign': 'simbolo del kip',
  'tugrik sign': 'simbolo del tugrik',
  'drachma sign': 'simbolo della dracma',
  'german penny symbol': 'simbolo del pfennig tedesco',
  'peso sign': 'simbolo del peso',
  'guarani sign': 'simbolo del guaran\xec',
  'austral sign': "simbolo dell'austral",
  'hryvnia sign': 'simbolo della hryvnia',
  'cedi sign': 'simbolo del cedi',
  'livre tournois sign': 'simbolo della lira di Tours',
  'spesmilo sign': 'simbolo dello spesmilo',
  'tenge sign': 'simbolo del tenge',
  'indian rupee sign': 'simbolo della rup\xeca indiana',
  'turkish lira sign': 'simbolo della lira turca',
  'nordic mark sign': 'simbolo del marco nordico',
  'manat sign': 'simbolo del manat',
  'ruble sign': 'simbolo del rublo',
  'yen character': 'simbolo dello yen',
  'yuan character': 'simbolo dello yuan',
  'yuan character, in hong kong and taiwan':
    'simbolo dello yuan, Hong Kong e Taiwan',
  'yen/yuan character variant one': 'simbolo yen/yuan variante uno',
  Emojis: 'Emojis',
  'Emojis...': 'Emojis...',
  'Loading emojis...': 'Caricamento emojis...',
  'Could not load emojis': 'Non posso caricare le emojis',
  People: 'Persone',
  'Animals and Nature': 'Animali e natura',
  'Food and Drink': 'Cibi e bevande',
  Activity: 'Attivit\xe0',
  'Travel and Places': 'Viaggi e luoghi',
  Objects: 'Oggetti',
  Flags: 'Bandiere',
  Characters: 'Caratteri',
  'Characters (no spaces)': 'Caratteri (senza spazi)',
  '{0} characters': '{0} caratteri',
  'Error: Form submit field collision.':
    'Errore: Conflitto di campi nel modulo inviato.',
  'Error: No form element found.': 'Errore: Nessun elemento di modulo trovato.',
  'Color swatch': 'Campione di colore',
  'Color Picker': 'Selezione colori',
  'Invalid hex color code: {0}': 'Codice esadecimale colore non valido: {0}',
  'Invalid input': 'Dato non valido',
  R: 'R',
  'Red component': 'Componente rosso',
  G: 'V',
  'Green component': 'Componente verde',
  B: 'B',
  'Blue component': 'Componente blu',
  '#': '#',
  'Hex color code': 'Colore esadecimale',
  'Range 0 to 255': 'Intervallo da 0 a 255',
  Turquoise: 'Turchese',
  Green: 'Verde',
  Blue: 'Blu',
  Purple: 'Viola',
  'Navy Blue': 'Blu scuro',
  'Dark Turquoise': 'Turchese scuro',
  'Dark Green': 'Verde scuro',
  'Medium Blue': 'Blu medio',
  'Medium Purple': 'Viola medio',
  'Midnight Blue': 'Blu notte',
  Yellow: 'Giallo',
  Orange: 'Arancio',
  Red: 'Rosso',
  'Light Gray': 'Grigio chiaro',
  Gray: 'Grigio',
  'Dark Yellow': 'Giallo scuro',
  'Dark Orange': 'Arancio scuro',
  'Dark Red': 'Rosso scuro',
  'Medium Gray': 'Grigio medio',
  'Dark Gray': 'Grigio scuro',
  'Light Green': 'Verde chiaro',
  'Light Yellow': 'Giallo chiaro',
  'Light Red': 'Rosso chiaro',
  'Light Purple': 'Viola chiaro',
  'Light Blue': 'Azzurro',
  'Dark Purple': 'Viola scuro',
  'Dark Blue': 'Blu scuro',
  Black: 'Nero',
  White: 'Bianco',
  'Switch to or from fullscreen mode':
    'Attiva/disattiva la modalit\xe0 schermo intero',
  'Open help dialog': 'Apri la finestra di aiuto',
  history: 'cronologia',
  styles: 'stili',
  formatting: 'formattazione',
  alignment: 'allineamento',
  indentation: 'indentazione',
  Font: 'Carattere',
  Size: 'Dimensione carattere',
  'More...': 'Altro\u2026',
  'Select...': 'Seleziona...',
  Preferences: 'Preferenze',
  Yes: 'S\xec',
  No: 'No',
  'Keyboard Navigation': 'Navigazione tramite tastiera',
  Version: 'Versione',
  'Code view': 'Visualizza codice',
  'Open popup menu for split buttons':
    'Apri il menu a comparsa per i pulsanti divisi',
  'List Properties': 'Propriet\xe0 Lista',
  'List properties...': 'Propriet\xe0 lista...',
  'Start list at number': 'La lista inizia con il numero',
  'Line height': 'Altezza linea',
  'Dropped file type is not supported': 'Tipo di file non supportato',
  'Loading...': 'Lettura in corso...',
  'ImageProxy HTTP error: Rejected request':
    'Errore HTTP ImageProxy: richiesta rifiutata',
  'ImageProxy HTTP error: Could not find Image Proxy':
    'Errore HTTP ImageProxy: impossibile trovare Image Proxy',
  'ImageProxy HTTP error: Incorrect Image Proxy URL':
    'Errore HTTP ImageProxy: URL Image Proxy non corretto',
  'ImageProxy HTTP error: Unknown ImageProxy error':
    'Errore HTTP ImageProxy: errore sconosciuto',
});
